import axios from 'axios';

const getSingleWarehouseApi = async (id, token) => {
  try {
    const res = await axios.get(`/Stock/single?stock_id=${id}`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'applications/json',
        Authorization: 'Bearer ' + token,
        lang: 'ar'
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getSingleWarehouseApi;
